import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";

import { Form, PasswordField } from "@sainsburys-tech/luna-form";
import {
  SubmitButton,
  Notification,
  NotificationStatuses,
  Card,
} from "@jsainsburyplc/id-ui-common";

import { validateForm } from "./utils";
import useCookies from "hooks/useCookies";

import ResetPasswordError from "./ResetPasswordError";
import PasswordTicksForgottenPassword from "./PasswordTicksForgottenPassword";

const INITAL_FORM_VALUES = {
  password: "",
  confirmPassword: "",
};

const ResetPassword = ({ onSubmit, isMultiMission = false }) => {
  const { email } = useCookies();
  const [passwordCriteria, setPasswordCriteria] = useState({});

  return (
    <Formik
      initialValues={useMemo(() => INITAL_FORM_VALUES, [])}
      validate={validateForm.bind(undefined, setPasswordCriteria)}
      validateOnMount={true}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        getFieldProps,
        errors,
        dirty,
        touched,
        isSubmitting,
        isValid,
        status = {},
      }) => (
        <Card>
          <Form onSubmit={handleSubmit}>
            {status.isError && (
              <ResetPasswordError
                errorCode={status.code}
                errorMessage={status.message}
              />
            )}
            <input
              name="username"
              defaultValue={email}
              autoComplete="username"
              style={{ display: "none" }}
            />
            <PasswordField
              name="password"
              label="New password"
              autoComplete="new-password"
              maxLength={22}
              {...getFieldProps("password")}
              error={dirty && touched.password && errors.password}
              required
              hasToggle
              aria-describedby="password-validation-length password-validation-content password-validation-specialchar password-validation-spaces password-validation-different"
            />
            <PasswordTicksForgottenPassword
              passwordValidation={{ ...passwordCriteria }}
            />
            <PasswordField
              name="confirmPassword"
              label="Confirm new password"
              autoComplete="new-password"
              maxLength={22}
              {...getFieldProps("confirmPassword")}
              error={dirty && touched.confirmPassword && errors.confirmPassword}
              required
              hasToggle
            />
            {isMultiMission && (
              <div className="ln-u-margin-bottom*4">
                <Notification type={NotificationStatuses.WARNING_TYPE}>
                  <span>
                    You will use this My ID to log in to both Nectar and
                    Sainsbury’s from now on.
                  </span>
                </Notification>
              </div>
            )}
            <div className="ln-u-text-align-center ln-u-push-top-sm">
              <SubmitButton
                data-testid="submit-button"
                label="Save new password"
                isLoadingLabel="Saving..."
                fullWidth={true}
                isLoading={isSubmitting}
                type="submit"
                disabled={isSubmitting || !isValid}
              />
            </div>
          </Form>
        </Card>
      )}
    </Formik>
  );
};

ResetPassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isMultiMission: PropTypes.bool,
};

export default ResetPassword;
